/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  // incidentMethodType,
  incidentTypeOptions,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation, useNavigate } from "react-router-dom";
import {
  formatName,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { debounce } from "lodash";
import EscalationActionButton from "./EscalationActionButton";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import { Checkbox } from "../../../components/ui/checkbox";
import UnauthorisedAccess from "../../../UnauthorisedAccess";
import moment from "moment";
import { Button } from "../../../components/ui/button";

// * Start: Escalation Listing Page
const Escalations = ({
  readAccess,
  writeAccess,
  dashboard = false,
  escalationType = "contact-escalations",
  amlDashboardValue,
  selectedMonthRange,
}) => {
  // * Start: Url Management State

  const { organizationData } = useOrganization();

  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [escalationsList, setEscalationsList] = useState([]);
  const [escalationLoading, setEscalationLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  // * End: List Management State

  /**
   * * Start: Fetch Escalation List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Escalation List
   **/

  const fetchEscalations = useCallback(
    async (passLimit, passPage) => {
      try {
        setEscalationLoading(true);
        const { data } = await get(
          `${API.GET_ESCALATIONS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_id=${trustId}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }&escalation_type=${escalationType ? escalationType : ""}&filter=${amlDashboardValue ? amlDashboardValue : ""}
          &start_date=${
            moment(selectedMonthRange?.start).format("MM-YYYY")
              ? moment(selectedMonthRange?.start).format("MM-YYYY")
              : ""
          }&end_date=${
            moment(selectedMonthRange?.end).format("MM-YYYY")
              ? moment(selectedMonthRange?.end).format("MM-YYYY")
              : ""
          }`,
        );
        setEscalationLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const escalationsList = data.data.data;
        setEscalationsList(escalationsList);
        return data.data;
      } catch (error) {
        setEscalationsList([]);
        setEscalationLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      searchParam,
      sortOrder,
      sortField,
      trustId,
      escalationType,
      amlDashboardValue,
      selectedMonthRange,
    ],
  );

  //* End: Fetch Escalation List Form The API

  const handleSubmitted = async (submitted, id) => {
    try {
      setEscalationLoading(true);
      const formData = new FormData();
      formData.append("submitted", submitted ? 1 : 0);
      await fileUpload(`${API.ESCALATION_SUBMITTED}/${id}`, formData);
      setEscalationLoading(false);
      fetchEscalations();
    } catch (error) {
      setEscalationLoading(false);
    }
  };

  /**
   * * Start: Escalation Table List Record Generation
   * @param {Number} quantity (Number of Escalations)
   * @returns {Array} Escalation List
   **/

  const escalationsGenerator = (quantity) => {
    const items = [];
    if (escalationType == "report-escalations") {
      for (let i = 0; i < quantity; i++) {
        let incidentItem = escalationsList[i]?.incident;
        let contactKYC = escalationsList[i]?.kyc;
        let contact = contactKYC?.joint_account_id
          ? contactKYC?.joint_account
          : contactKYC?.beneficiary_id
            ? contactKYC?.beneficiary
            : contactKYC?.vendor_id
              ? contactKYC?.vendor
              : contactKYC?.contact_id
                ? contactKYC?.contact
                : "";
        items.push({
          key: escalationsList[i]?.id,
          id: escalationsList[i]?.id ? escalationsList[i]?.id : "",
          incident_type: incidentItem?.incident_type
            ? incidentTypeOptions?.find(
                (item) => item.value == incidentItem?.incident_type,
              )?.label
            : "",
          contactable_type: contactKYC?.joint_account_id
            ? "Joint Account"
            : contactKYC?.beneficiary_id
              ? "Beneficiary"
              : contactKYC?.vendor_id
                ? getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor",
                  )
                : contactKYC?.contact_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )
                  : "",
          contact_name:
            formatName(contact?.first_name, contact?.last_name) +
            (contact?.business_name ? ` (${contact?.business_name})` : ""),
          incident_date: incidentItem?.incident_date
            ? incidentItem?.incident_date
            : "",
          // method: incidentItem?.method
          //   ? incidentMethodType?.find(
          //       (item) => item.value == incidentItem?.method,
          //     )?.label
          //   : "",
          // amount: incidentItem?.amount ? incidentItem?.amount : "",
          escalated_by: escalationsList[i]?.user
            ? formatSubcontractorName(escalationsList[i]?.user)
            : "",
          escalated_to: escalationsList[i]?.compliance_manager
            ? formatSubcontractorName(escalationsList[i]?.compliance_manager)
            : "",
          approved_date: escalationsList[i]?.approved_date
            ? escalationsList[i]?.approved_date
            : "",
          approved: escalationsList[i]?.approved ? (
            <Button size={"sm"} className="h-6 px-2 bg-[#0da500] w-fit">
              Approved
            </Button>
          ) : (
            ""
          ),
          approved_by: escalationsList[i]?.approved_by
            ? formatSubcontractorName(escalationsList[i]?.approved_by)
            : "",
          reason: escalationsList[i]?.reason ? (
            <div
              className="max-w-[250px] line-clamp-2 truncate"
              title={escalationsList[i]?.reason}
            >
              {escalationsList[i]?.reason}
            </div>
          ) : (
            ""
          ),
          action: (
            <EscalationActionButton
              id={escalationsList[i]?.id}
              trustId={trustId}
              escalation={escalationsList[i]}
              approved={escalationsList[i]?.approved}
              fetchEscalations={() => fetchEscalations()}
              approvalPremission={
                escalationsList[i]?.approval_permission
                  ? escalationsList[i]?.approval_permission
                  : ""
              }
              setLoading={setEscalationLoading}
            />
          ),
          submitted: (
            <div className={`flex justify-center`}>
              <Checkbox
                checked={escalationsList[i]?.submitted ? true : false}
                onCheckedChange={() =>
                  handleSubmitted(
                    escalationsList[i]?.submitted ? false : true,
                    escalationsList[i]?.id,
                  )
                }
              />
            </div>
          ),
        });
      }
    } else {
      for (let i = 0; i < quantity; i++) {
        let contactKYC = escalationsList[i]?.kyc;
        let contact = contactKYC?.joint_account_id
          ? contactKYC?.joint_account
          : contactKYC?.beneficiary_id
            ? contactKYC?.beneficiary
            : contactKYC?.vendor_id
              ? contactKYC?.vendor
              : contactKYC?.contact_id
                ? contactKYC?.contact
                : "";
        items.push({
          key: escalationsList[i]?.id,
          id: escalationsList[i]?.id ? escalationsList[i]?.id : "",
          contact_type: contactKYC?.joint_account_id
            ? "Joint Account"
            : contactKYC?.beneficiary_id
              ? "Beneficiary"
              : contactKYC?.vendor_id
                ? getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "vendors",
                    "Vendor",
                  )
                : contactKYC?.contact_id
                  ? getModuleNamingBySlug(
                      organizationData?.organizationData,
                      "contacts",
                      "Customer",
                    )
                  : "",
          code: contact?.code ? contact?.code : "",
          name:
            formatName(contact?.first_name, contact?.last_name) +
            (contact?.business_name ? ` (${contact?.business_name})` : ""),
          email: contact?.email,
          contact: contact,
          escalated_by: escalationsList[i]?.user
            ? formatSubcontractorName(escalationsList[i]?.user)
            : "",
          escalated_to: escalationsList[i]?.compliance_manager
            ? formatSubcontractorName(escalationsList[i]?.compliance_manager)
            : "",
          reason: escalationsList[i]?.reason ? (
            <div
              className="max-w-[250px] line-clamp-2 truncate"
              title={escalationsList[i]?.reason}
            >
              {escalationsList[i]?.reason}
            </div>
          ) : (
            ""
          ),
          approved: escalationsList[i]?.approved ? (
            <Button size={"sm"} className="h-6 px-2 bg-[#0da500] w-fit">
              Approved
            </Button>
          ) : (
            ""
          ),
          approved_date: escalationsList[i]?.approved_date
            ? escalationsList[i]?.approved_date
            : "",
          approved_by: escalationsList[i]?.approved_by
            ? formatSubcontractorName(escalationsList[i]?.approved_by)
            : "",
          action: (
            <EscalationActionButton
              id={escalationsList[i]?.id}
              trustId={trustId}
              escalation={escalationsList[i]}
              approved={escalationsList[i]?.approved}
              fetchEscalations={() => fetchEscalations()}
              approvalPremission={
                escalationsList[i]?.approval_permission
                  ? escalationsList[i]?.approval_permission
                  : ""
              }
              setLoading={setEscalationLoading}
            />
          ),
          // submitted: (
          //   <div className={`flex justify-center`}>
          //     <Checkbox
          //       checked={escalationsList[i]?.submitted ? true : false}
          //       onCheckedChange={() =>
          //         handleSubmitted(
          //           escalationsList[i]?.submitted ? false : true,
          //           escalationsList[i]?.id,
          //         )
          //       }
          //     />
          //   </div>
          // ),
        });
      }
    }

    return items;
  };

  const escalations = escalationsGenerator(escalationsList?.length);

  //* End: Escalation Table List Record Generation

  //* Start: Escalation List Columns

  const columns =
    escalationType == "report-escalations"
      ? [
          {
            dataField: "incident_type",
            text: "Incident Type",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "contactable_type",
            text: "Type",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "contact_name",
            text: "Contact Name",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "incident_date",
            text: "Incident Date",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          // {
          //   dataField: "method",
          //   text: "Method",
          //   sort: true,
          //   sortCaret,
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          // },
          // {
          //   dataField: "amount",
          //   text: "Amount",
          //   sort: true,
          //   sortCaret,
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          // },
          {
            dataField: "escalated_by",
            text: "Escalated By",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "escalated_to",
            text: "Escalation Assigned To",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "reason",
            text: "Reason for Escalation",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          // {
          //   dataField: "approved",
          //   text: "Status",
          //   sort: true,
          //   sortCaret,
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          // },
          {
            dataField: "approved_date",
            text: "Approved Date",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "approved_by",
            text: "Approved By",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },

          {
            dataField: "action",
            text: "Action",
            align: "center",
            headerAlign: "center",
            // style: { width: "127px" },
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "submitted",
            text: "Submitted",
            align: "center",
            headerAlign: "center",
            style: { width: "127px" },
            headerClasses: THClasses,
            classes: TDClasses,
          },
        ]
      : [
          {
            dataField: "contact_type",
            text: "Type",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "code",
            text: "Code",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "name",
            text: "Name",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "email",
            text: "Email",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "escalated_by",
            text: "Escalated By",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "escalated_to",
            text: "Escalation Assigned To",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "reason",
            text: "Reason for Escalation",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          // {
          //   dataField: "approved",
          //   text: "Status",
          //   sort: true,
          //   sortCaret,
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          // },
          {
            dataField: "approved_date",
            text: "Approved Date",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },
          {
            dataField: "approved_by",
            text: "Approved By",
            sort: true,
            sortCaret,
            headerClasses: THClasses,
            classes: TDClasses,
          },

          {
            dataField: "action",
            text: "Action",
            align: "center",
            headerAlign: "center",
            // style: { width: "127px" },
            headerClasses: THClasses,
            classes: TDClasses,
          },
          // {
          //   dataField: "submitted",
          //   text: "Submitted",
          //   align: "center",
          //   headerAlign: "center",
          //   style: { width: "127px" },
          //   headerClasses: THClasses,
          //   classes: TDClasses,
          // },
        ];

  //* End: Escalation List Columns

  /**
   * * Start: Escalation List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Escalation List Sorting

  /**
   * * Start: Escalation List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchEscalations(limit, 1);
  };

  //* End: Escalation List Change Limit

  /**
   * * Start: Escalation List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchEscalations(limit, page);
  };

  //* End: Escalation List Change Page

  //* Start: Escalation List and URL Mangement useEffect

  useEffect(() => {
    if (dashboard) {
      navigate(
        `?tab=dashboard&childTab=escalations&subChildTab=${escalationType}&limit=${limit ? limit : defaultLimitPagination}&page=${
          page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${
          sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}&from=${
          moment(selectedMonthRange?.start).format("MM-YYYY")
            ? moment(selectedMonthRange?.start).format("MM-YYYY")
            : ""
        }&to=${
          moment(selectedMonthRange?.end).format("MM-YYYY")
            ? moment(selectedMonthRange?.end).format("MM-YYYY")
            : ""
        }`,
        {
          replace: true,
        },
      );
    } else {
      navigate(
        `?tab=escalations&childTab=${escalationType}&limit=${limit ? limit : defaultLimitPagination}&page=${
          page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${
          sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}&from=${
          moment(selectedMonthRange?.start).format("MM-YYYY")
            ? moment(selectedMonthRange?.start).format("MM-YYYY")
            : ""
        }&to=${
          moment(selectedMonthRange?.end).format("MM-YYYY")
            ? moment(selectedMonthRange?.end).format("MM-YYYY")
            : ""
        }`,
        {
          replace: true,
        },
      );
    }
  }, [
    navigate,
    limit,
    searchParam,
    page,
    sortField,
    sortOrder,
    dashboard,
    escalationType,
    selectedMonthRange,
  ]);

  useEffect(() => {
    fetchEscalations();
  }, [fetchEscalations]);

  //* End: Escalation List and URL Mangement useEffect

  //* Start: Escalation List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //* End: Escalation List Search Record Management

  return readAccess ? (
    <MainBody
      searchParamData={searchParamData}
      handleClearSearch={handleClearSearch}
      handleSearchChange={handleSearchChange}
      loading={escalationLoading}
      innerBody={true}
      parentHeight={true}
      mainClassName="w-[calc(100%-3rem)]"
    >
      {/* Escalation Table and Pagination */}
      <div className="custom-table">
        <div
          className={`table-body-class ${dashboard ? "max-h-[400px]" : "max-h-[500px]"}`}
        >
          <BootstrapTable
            keyField="escalation_id"
            remote
            data={escalations}
            columns={columns}
            onTableChange={handleTableChange}
            // expandRow={expandRow}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Pagination
          total={total}
          limit={parseInt(limit)}
          currentPage={page}
          updateLimit={handleUpdateLimit}
          updatePage={handleChangePage}
          from={from}
          to={to}
        />
      </div>
    </MainBody>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default Escalations;
// * End: Escalation Listing Page
